<script lang="ts">
    import type { InputType } from "../dao";
    import { ModelName } from "../schema";
    export let gif: InputType<ModelName.Gif>;
</script>
<div class="flex w-full h-full tems-stretch">
    <iframe title="{gif.correct ? 'Success' : 'Fail'} animation" src="https://giphy.com/embed/{gif.gid}" frameBorder="0" class="giphy-embed grow"/>
</div>
